import * as z from "zod";

export interface IntegrationSettings {
  connect: z.ZodType;
  update: z.ZodType;
  read: z.ZodType;
  writeKeys: string[];
  readKeys: string[];
  secretKeys: string[];
}

/**
 * `secrets` are accepted on write and never returned by `read`; `computed` is
 * server-owned and only ever returned.
 */
export function defineIntegrationSettings<
  Fields extends z.ZodRawShape,
  Secrets extends z.ZodRawShape,
  Computed extends z.ZodRawShape,
>(buckets: { fields: Fields; secrets: Secrets; computed: Computed }) {
  const connect = z.object(buckets.fields).extend(buckets.secrets);
  const read = z.object(buckets.fields).extend(buckets.computed);
  return {
    connect,
    update: connect.partial(),
    read,
    writeKeys: Object.keys(connect.shape),
    readKeys: Object.keys(read.shape),
    secretKeys: Object.keys(buckets.secrets),
  };
}
